:host {
  display: block;
  height: auto;
  max-width: 100%;
}

.selected-item {
  padding: calc(var(--spacer) / 2) 0;
}

gz-icon-button[icon='ds-icon-delete_large'] {
  display: flex;
}
